export default function ConfirmLiveModal({ open, onCancel, onConfirm }) {
    if (!open) return null;
    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
            <div className="bg-zinc-900 rounded-2xl p-6 max-w-md w-full space-y-3">
                <h3 className="text-xl font-semibold">Confirm Live Order</h3>
                <p className="text-sm text-zinc-300">
                    You are about to send a <b>LIVE</b> order. Confirm you understand this may result in real trades.
                </p>
                <ul className="text-xs text-zinc-400 list-disc pl-5">
                    <li>Orders are subject to your risk caps.</li>
                    <li>Check symbol, side, quantity, and order type.</li>
                </ul>
                <div className="flex gap-2 justify-end pt-2">
                    <button onClick={onCancel} className="px-4 py-2 rounded bg-zinc-700">Cancel</button>
                    <button onClick={onConfirm} className="px-4 py-2 rounded bg-red-600">I Understand � Place Order</button>
                </div>
            </div>
        </div>
    );
}
